import * as ActionsTypes from "../../../../common/constants/stateConstants";
import {objectContentElementInitialState, updateState,} from "../../../../common/utils/helpers";

const initialState = {
  package: { ...objectContentElementInitialState },
};

/*-------------------------------------------------GET-DETAIL-PACKAGE----------------------------------------------------*/
const getDetailPackage = (state) => {
  return updateState("package", state, {
    ...objectContentElementInitialState,
    isLoading: true,
  });
};

const getDetailPackageSuccess = (state, payload) => {
  return updateState("package", state, {
    content: payload,
    isLoading: false,
    isSuccessed: true,
  });
};

const getDetailPackageFail = (state, payload) => {
  return updateState("package", state, {
    error: payload,
    isLoading: false,
    hasError: true,
  });
};

/*************************************************************************** */
const detailPackageReducer = (state = initialState, action) => {
  switch (action.type) {
    /*------------------------------------------------GET-DETAIL-PACKAGE----------------------------------------------------*/
    case ActionsTypes.GET_DETAIL_PACKAGE:
      return getDetailPackage(state, action);
    case ActionsTypes.GET_DETAIL_PACKAGE_SUCCESS:
      return getDetailPackageSuccess(state, action.payload);
    case ActionsTypes.GET_DETAIL_PACKAGE_FAIL:
      return getDetailPackageFail(state, action.payload);
    default:
      return state;
  }
};

export default detailPackageReducer;
